export default {
    csManagement: {
        page: {
            title: 'CS 管理中心',
            description: '管理租戶配額、文件總量和 Token 消耗控制',
        },
        quota: {
            searchPlaceholder: '搜尋租戶 ID',
            typePlaceholder: '配額類型',
            search: '搜尋',
            create: '新增配額',
            tenantId: '租戶 ID',
            quotaType: '配額類型',
            typeDocument: '文件總量',
            typeToken: 'Token 消耗總量',
            quotaLimit: '配額上限',
            quotaUsed: '已使用',
            contractPeriod: '合約期',
            contractStart: '合約開始',
            contractEnd: '合約結束',
            status: '狀態',
            statusActive: '生效中',
            statusExpired: '已過期',
            remark: '備註',
            action: '操作',
            edit: '編輯',
            delete: '刪除',
            createTitle: '新增配額',
            editTitle: '編輯配額',
            cancel: '取消',
            confirm: '確認',
        },
    },
}
